<template>
<div class="chapter">
<div class="inner_page">
<div id="Cover.html" xml:lang="en-US">
<div class="Basic-Graphics-Frame">
<p class="x1cover-image" id="toc_marker-1"><img alt="cover.jpg" class="cvr" src="images/9780738735542_fmt.jpeg" width="95%"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cover.vue?24647c32